module.exports = __webpack_public_path__ + "assets/皇冠VIP3.da73a5e2.svg";